module.exports = __webpack_public_path__ + "static/media/close.e3ec3654.png";